export const STATE_EVENTS = {
  UPDATE: 'update',
  SHCEME_DATA_LOADED: 'schemeDataLoaded',
  TICKETS_DATA_LOADED: 'ticketsDataLoaded',
  DATA_LOADED: 'dataLoaded',
  SCHEME_MODE_CHANGE: 'schemeModeChange',
  WIDGET_RERENDER: 'widgetRerender',
  WIDGET_RELOAD_TICKETS: 'widgetReloadTickets',
  RELOAD_TICKETS: 'reloadTickets',
};
